import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { startCheckout } from '../../lib/metaPixel';
import { SecretPortalReveal } from '../shared/SecretPortalReveal';
const PRODUCTOS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/mm8DHXzU7JhvCgYay4N1kmyc5Q2WN4pg9GNtp0heMg7BSrM3QpCC0xGOYBCXzy5-GOp2Z8fowqxSWnS4ldgA120xXC67zpfx2qL_wjuAepxGwDo6ErItRpus49bMEA7U.jpg?v=1778629864';
const GOLD = '#C9A84C';
const GOLD_LIGHT = '#E8D48B';
const GOLD_DEEP = '#9E823B';
/**
 * Checkout URL for the full 12-Reinos system access.
 * TODO: replace this placeholder with the real Shopify variant checkout URL
 * when the bundle product is created.
 */
const SISTEMA_CHECKOUT_URL = 'https://los12reinos.com/cart/42780064645214:1';
// ── Sigils ────────────────────────────────────────────────────────────
const SigilCore = ({
  color
}: {
  color: string;
}) => <svg width="40" height="40" viewBox="0 0 44 44" fill="none" data-id="element-284">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-285" />
    <circle cx="22" cy="22" r="12" stroke={color} strokeWidth="0.6" strokeDasharray="2 3" opacity="0.7" data-id="element-286" />
    <circle cx="22" cy="22" r="4" fill={color} data-id="element-287" />
  </svg>;
const SigilShadow = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-288">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-289" />
    <path d="M22 6 L30 22 L22 38 L14 22 Z" stroke={color} strokeWidth="1" fill={color} fillOpacity="0.15" data-id="element-290" />
    <circle cx="22" cy="22" r="4" fill={color} data-id="element-291" />
  </svg>;
const SigilRitual = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-292">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-293" />
    <circle cx="22" cy="22" r="10" fill={color} fillOpacity="0.15" data-id="element-294" />
    <path d="M14 22 A8 8 0 0 1 30 22" stroke={color} strokeWidth="1.2" fill="none" data-id="element-295" />
    <circle cx="14" cy="22" r="1.5" fill={color} data-id="element-296" />
    <circle cx="30" cy="22" r="1.5" fill={color} data-id="element-297" />
  </svg>;
const SigilCamara = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-298">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-299" />
    {[0, 72, 144, 216, 288].map(a => <line key={a} x1="22" y1="22" x2="22" y2="6" stroke={color} strokeWidth="0.7" opacity="0.7" transform={`rotate(${a} 22 22)`} data-id="element-300" />)}
    <circle cx="22" cy="22" r="3" fill={color} data-id="element-301" />
  </svg>;
const SigilCompat = ({
  color
}: {
  color: string;
}) => <svg width="36" height="36" viewBox="0 0 44 44" fill="none" data-id="element-302">
    <circle cx="14" cy="22" r="10" stroke={color} strokeWidth="0.8" opacity="0.7" data-id="element-303" />
    <circle cx="30" cy="22" r="10" stroke={color} strokeWidth="0.8" opacity="0.7" data-id="element-304" />
    <circle cx="22" cy="22" r="2.5" fill={color} data-id="element-305" />
  </svg>;
const SigilSistema = ({
  color
}: {
  color: string;
}) => <svg width="48" height="48" viewBox="0 0 44 44" fill="none" data-id="element-306">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-307" />
    {Array.from({
    length: 12
  }).map((_, i) => <line key={i} x1="22" y1="4" x2="22" y2="8" stroke={color} strokeWidth="0.9" transform={`rotate(${i * 30} 22 22)`} data-id="element-308" />)}
    <circle cx="22" cy="22" r="10" stroke={color} strokeWidth="0.6" strokeDasharray="2 3" opacity="0.7" data-id="element-309" />
    <circle cx="22" cy="22" r="3" fill={color} data-id="element-310" />
  </svg>;
const scrollToGrid = () => {
  document.getElementById('sign-grid')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function Productos() {
  return <section id="home-offers" className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden" data-id="element-311">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-312">
        <img src={PRODUCTOS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-313" />
        <div className="absolute inset-0 bg-cosmic-black/85" data-id="element-314" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.5) 50%, #050508 100%)'
      }} data-id="element-315" />
      </div>

      <div className="relative z-10 container mx-auto max-w-6xl" data-id="element-316">
        <AnimatedSection data-id="element-317">
          <div className="text-center mb-16 md:mb-20 px-2" data-id="element-318">
            <motion.div className="inline-flex items-center gap-3 mb-6" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} data-id="element-319">
              <div className="h-px w-10 md:w-12 bg-gradient-to-r from-transparent to-gold-primary" data-id="element-320" />
              <span className="md:text-[11px] tracking-[0.35em] uppercase font-serif text-gold-light text-[14px]" data-id="element-321">
                Accesos al Sistema
              </span>
              <div className="h-px w-10 md:w-12 bg-gradient-to-r from-gold-primary to-transparent" data-id="element-322" />
            </motion.div>

            <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-323">
              Elige cómo quieres entrar a LOS 12
            </h2>
            <p className="max-w-2xl mx-auto md:text-xl italic text-[18px] font-['DM_Sans',_sans-serif]" style={{
            color: 'rgba(232,212,139,0.9)'
          }} data-id="element-324">
              Tu puerta de entrada a un Reino, o al universo completo de LOS 12.
            </p>
            <p className="max-w-2xl mx-auto mt-4 md:text-lg text-[16px] font-['DM_Sans',_sans-serif]" style={{
            color: 'rgba(232,212,139,0.78)'
          }} data-id="element-325">
              Accede a las 12 experiencias inmersivas y todos los documentos
              exclusivos del sistema LOS 12.
            </p>
          </div>
        </AnimatedSection>

        {/* ─── Tier 2 — Experiencia Recomendada · $24.99 ──────────── */}
        <AnimatedSection delay={0.22} data-id="element-326">
          <div className="mb-12 md:mb-16" data-id="element-327">
            <ExperienciaCompleta data-id="element-328" />
          </div>
        </AnimatedSection>

        {/* ─── Tier 3 — Secret Portal Reveal ($89.88) ────────────── */}
        <AnimatedSection delay={0.3} data-id="element-329">
          <SecretPortalReveal signName="Sistema Completo" checkoutUrl={SISTEMA_CHECKOUT_URL} data-id="element-330" />
        </AnimatedSection>
      </div>
    </section>;
}
// ═══════════════════════════════════════════════════════════════════════
// TIER 1 — Acceso Esencial · "El Núcleo de tu Reino" · $12.69
// ═══════════════════════════════════════════════════════════════════════
function AccesoEsencial() {
  const PRICE = 12.69;
  const includes = ['Libro principal - 60 Paginas Full Color', 'Descubrimiento de tu Reino', 'Patrón dominante', 'Identidad emocional central', 'NO INCLUYE PORTAL DE USUARIO', 'NO INCLUYE EXPERIENCIA INMERSIVA'];
  return <motion.div className="relative border rounded-2xl p-8 md:p-12 text-center overflow-hidden max-w-2xl mx-auto" style={{
    borderColor: `${GOLD}55`,
    background: `linear-gradient(145deg, rgba(10,10,18,0.95) 0%, rgba(201,168,76,0.10) 100%)`,
    boxShadow: `0 0 30px rgba(201,168,76,0.2), inset 0 0 22px rgba(201,168,76,0.08)`
  }} whileHover={{
    y: -3
  }} transition={{
    type: 'spring',
    stiffness: 200,
    damping: 22
  }} data-id="element-331">
      <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
      boxShadow: ['inset 0 0 22px rgba(201,168,76,0.10)', 'inset 0 0 45px rgba(201,168,76,0.22)', 'inset 0 0 22px rgba(201,168,76,0.10)']
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-332" />

      <div className="relative" data-id="element-333">
        <p className="tracking-[0.35em] uppercase font-serif mb-4 opacity-80 text-[14px]" style={{
        color: GOLD_LIGHT
      }} data-id="element-334">
          Acceso Esencial · $12.69
        </p>

        <div className="flex justify-center mb-5" data-id="element-335">
          <SigilCore color={GOLD} data-id="element-336" />
        </div>

        <h3 className="text-3xl md:text-4xl font-serif font-bold mb-4" style={{
        color: '#F5F0E1',
        textShadow: `0 0 18px rgba(201,168,76,0.5)`
      }} data-id="element-337">
          El Núcleo de tu Reino
        </h3>

        <p className="text-base md:text-lg text-gray-200 leading-relaxed mb-7 max-w-md mx-auto font-serif italic" data-id="element-338">
          Tu puerta de entrada al patrón emocional que domina tu identidad.
        </p>

        {/* Includes list */}
        <ul className="text-left max-w-sm mx-auto mb-8 space-y-3" data-id="element-339">
          {includes.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-340">
              <span className="inline-block w-2 h-2 rotate-45 flex-shrink-0" style={{
            backgroundColor: GOLD,
            boxShadow: `0 0 6px ${GOLD}`
          }} data-id="element-341" />
              <span className="font-serif text-base md:text-lg text-gray-100" data-id="element-342">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="text-5xl md:text-6xl font-bold mb-8 font-serif" style={{
        color: GOLD,
        textShadow: `0 0 20px rgba(201,168,76,0.8)`
      }} data-id="element-343">
          ${PRICE}
        </p>

        <motion.button onClick={scrollToGrid} className="w-full sm:w-auto inline-block px-10 py-5 font-bold rounded-xl text-base md:text-lg tracking-[0.15em]" style={{
        backgroundColor: GOLD,
        color: '#050508',
        boxShadow: '0 0 30px rgba(201,168,76,0.55)'
      }} whileHover={{
        scale: 1.03,
        boxShadow: '0 0 50px rgba(201,168,76,0.9)'
      }} whileTap={{
        scale: 0.97
      }} data-id="element-344">
          DESBLOQUEA TU REINO
        </motion.button>
        <div className="flex items-center justify-center mb-8" data-id="element-345">
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#d4af37]/60" data-id="element-346"></div>
          <p className="px-4 md:text-sm uppercase tracking-[0.35em] text-[#d4af37]/80 font-light text-[14px]" data-id="element-347">
            Selecciona tu signo
          </p>
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#d4af37]/60" data-id="element-348"></div>
        </div>
      </div>
    </motion.div>;
}
// ═══════════════════════════════════════════════════════════════════════
// TIER 2 — Experiencia Recomendada · "Desbloqueo Total del Reino" · $24.99
// ═══════════════════════════════════════════════════════════════════════
function ExperienciaCompleta() {
  const PRICE = 24.99;
  const ORIGINAL = 54.95;
  const items = [{
    sigil: <SigilCore color={GOLD} data-id="element-349" />,
    title: '📘 Documento Principal - Núcleo del Arquetipo',
    desc: 'Descubre la estructura emocional que dirige tu forma de sentir, reaccionar y decidir.'
  }, {
    sigil: <SigilShadow color={GOLD} data-id="element-350" />,
    title: '📘 Experiencia Privada de Lectura - Archivo Sombrío',
    desc: 'Explora los patrones ocultos y emociones repetitivas que siguen influyendo en tus relaciones y decisiones.'
  }, {
    sigil: <SigilRitual color={GOLD} data-id="element-351" />,
    title: '📘 Guía de Transformación Interna - Ritual del Eclipse',
    desc: 'Una experiencia diseñada para ayudarte a observar y romper ciclos emocionales inconscientes.'
  }, {
    sigil: <SigilCompat color={GOLD} data-id="element-352" />,
    title: '📘 Documento de Vínculos y Patrones - Códice de Compatibilidad',
    desc: 'Comprende por qué atraes ciertos tipos de personas y dinámicas emocionales repetitivas.'
  }];
  return <motion.div className="relative border rounded-2xl p-8 md:p-12 text-center overflow-hidden max-w-3xl mx-auto" style={{
    borderColor: `${GOLD_LIGHT}55`,
    background: `linear-gradient(145deg, rgba(10,10,18,0.96) 0%, rgba(232,212,139,0.10) 100%)`,
    boxShadow: `0 0 36px rgba(232,212,139,0.28), inset 0 0 26px rgba(232,212,139,0.08)`
  }} whileHover={{
    y: -3
  }} transition={{
    type: 'spring',
    stiffness: 200,
    damping: 22
  }} data-id="element-353">
      {/* Ambient pulse */}
      <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
      boxShadow: ['inset 0 0 22px rgba(232,212,139,0.10)', 'inset 0 0 48px rgba(232,212,139,0.25)', 'inset 0 0 22px rgba(232,212,139,0.10)']
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-354" />

      <div className="relative" data-id="element-355">
        {/* Recommended badge */}
        <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full mb-5" style={{
        background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_LIGHT} 100%)`,
        color: '#050508',
        boxShadow: `0 0 18px ${GOLD_LIGHT}80`
      }} data-id="element-356">
          <span className="text-[11px] md:text-[12px] tracking-[0.25em] sm:tracking-[0.3em] uppercase font-serif font-bold" data-id="element-357">
            Experiencia Recomendada
          </span>
        </div>

        <p className="text-[11px] md:text-[12px] tracking-[0.3em] sm:tracking-[0.35em] uppercase font-serif mb-3 opacity-80" style={{
        color: GOLD_LIGHT
      }} data-id="element-358">
          Experiencia Completa · $24.99
        </p>

        <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 leading-tight" style={{
        color: '#F5F0E1',
        textShadow: `0 0 22px ${GOLD_LIGHT}60`
      }} data-id="element-359">
          Desbloqueo Total del Reino
        </h3>

        <p className="text-base md:text-lg text-gray-200 leading-relaxed mb-8 max-w-xl mx-auto font-serif italic" data-id="element-360">
          Accede a todas las capas emocionales y psicológicas de tu Reino.
        </p>

        {/* 4 archive items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mb-6 max-w-2xl mx-auto text-left" data-id="element-361">
          {items.map((item, i) => <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl" style={{
          background: 'linear-gradient(135deg, rgba(12,12,20,0.7) 0%, rgba(8,8,14,0.65) 100%)',
          border: `1px solid ${GOLD_LIGHT}1F`
        }} data-id="element-362">
              <div className="flex-shrink-0" data-id="element-363">{item.sigil}</div>
              <div className="min-w-0" data-id="element-364">
                <p className="text-[15px] md:text-base font-serif font-semibold mb-1" style={{
              color: '#F5F0E1'
            }} data-id="element-365">
                  {item.title}
                </p>
                <p className="text-[13px] md:text-sm italic leading-snug font-['DM_Sans',_sans-serif]" style={{
              color: 'rgba(232,212,139,0.78)'
            }} data-id="element-366">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Exclusive Portal access — Cámara Astral · centered hero block */}
        <motion.div className="relative max-w-2xl mx-auto mb-10 md:mb-12 rounded-2xl px-6 py-8 md:px-10 md:py-12 text-center overflow-hidden" style={{
        background: 'linear-gradient(135deg, rgba(201,168,76,0.16) 0%, rgba(8,8,14,0.92) 100%)',
        border: `1px solid ${GOLD}66`,
        boxShadow: `inset 0 0 28px ${GOLD}1F, 0 0 28px ${GOLD}30`
      }} initial={{
        opacity: 0,
        y: 8
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-367">
          {/* Soft top halo */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none" style={{
          width: '120%',
          height: 180,
          background: `radial-gradient(ellipse at top, ${GOLD}33 0%, transparent 65%)`,
          filter: 'blur(18px)'
        }} data-id="element-368" />

          <div className="relative" data-id="element-369">
            <p className="text-[11px] md:text-[12px] tracking-[0.35em] sm:tracking-[0.45em] uppercase font-serif font-semibold mb-5" style={{
            color: GOLD_LIGHT,
            textShadow: `0 0 10px ${GOLD}70`
          }} data-id="element-370">
              Acceso Exclusivo
            </p>

            {/* Centered sigil — scaled up for hero presence */}
            <div className="flex justify-center mb-5" style={{
            transform: 'scale(1.6)',
            transformOrigin: 'center'
          }} data-id="element-371">
              <SigilCamara color={GOLD_LIGHT} data-id="element-372" />
            </div>

            <h4 className="text-[28px] md:text-[36px] lg:text-[42px] font-serif font-bold mb-4 leading-tight" style={{
            color: '#F5F0E1',
            textShadow: `0 0 18px ${GOLD}90, 0 2px 14px rgba(0,0,0,0.6)`
          }} data-id="element-373">
              Cámara Astral
            </h4>

            <p className="text-[14px] md:text-[16px] lg:text-[17px] font-serif italic leading-relaxed mb-5 max-w-md mx-auto" style={{
            color: 'rgba(245,240,225,0.92)'
          }} data-id="element-374">
              Tu espacio privado dentro del Reino. Accede a todos los
              documentos, archivos desbloqueados y experiencias relacionadas con
              tu energía.
            </p>

            <p className="text-[11.5px] md:text-[13px] tracking-[0.3em] sm:tracking-[0.4em] uppercase font-serif font-semibold" style={{
            color: GOLD_LIGHT,
            textShadow: `0 0 10px ${GOLD}70`
          }} data-id="element-375">
              — Portal de Usuario —
            </p>
          </div>
        </motion.div>

        {/* Price block — strikethrough + final */}
        <div className="flex items-baseline justify-center gap-3 mb-8" data-id="element-376">
          <span className="text-2xl md:text-3xl font-serif line-through" style={{
          color: 'rgba(232,212,139,0.4)'
        }} data-id="element-377">
            ${ORIGINAL}
          </span>
          <span className="text-5xl md:text-6xl font-bold font-serif" style={{
          color: GOLD_LIGHT,
          textShadow: `0 0 22px ${GOLD_LIGHT}A0`
        }} data-id="element-378">
            ${PRICE}
          </span>
        </div>

        <motion.button onClick={scrollToGrid} className="w-full sm:w-auto inline-block px-10 md:px-12 py-5 md:py-6 font-bold rounded-xl text-base md:text-lg tracking-[0.15em]" style={{
        background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_LIGHT} 100%)`,
        color: '#050508',
        boxShadow: `0 0 32px ${GOLD_LIGHT}90`
      }} whileHover={{
        scale: 1.03,
        boxShadow: `0 0 50px ${GOLD_LIGHT}`
      }} whileTap={{
        scale: 0.97
      }} data-id="element-379">
          DESBLOQUEAR MI REINO COMPLETO
        </motion.button>

        <p className="mt-6 mb-3 font-serif font-semibold tracking-[0.18em] text-[15px] md:text-base" style={{
        color: GOLD_LIGHT,
        textShadow: `0 0 14px ${GOLD_LIGHT}70`
      }} data-id="element-380">
          Vive una Experiencia Inmersiva
        </p>

        <p className="max-w-xl mx-auto text-[13.5px] md:text-sm italic leading-relaxed px-4 mb-8 font-['DM_Sans',_sans-serif]" style={{
        color: 'rgba(232,212,139,0.82)'
      }} data-id="element-381">
          Después de tu compra recibirás un acceso exclusivo a tu Portal del
          Reino. Todos tus archivos y experiencias estarán disponibles dentro de
          tu espacio privado, diseñado para explorar tu universo de forma
          inmersiva.
        </p>

        <div className="flex items-center justify-center" data-id="element-382">
          <div className="h-px w-10 sm:w-12 bg-gradient-to-r from-transparent to-[#d4af37]/60" data-id="element-383" />
          <p className="px-3 sm:px-4 text-[11.5px] md:text-sm uppercase tracking-[0.3em] sm:tracking-[0.35em] text-[#d4af37]/85 font-light" data-id="element-384">
            Selecciona tu signo
          </p>
          <div className="h-px w-10 sm:w-12 bg-gradient-to-l from-transparent to-[#d4af37]/60" data-id="element-385" />
        </div>
      </div>
    </motion.div>;
}